// A month is counted as 30 days and a year as 365, to match the per-day price
// the plan cards show.
export function getTotalDays({
  periodAmount,
  periodUnit,
}: {
  periodAmount: number
  periodUnit: string
}): number {
  switch (periodUnit) {
    case "week":
      return periodAmount * 7
    case "month":
      return periodAmount * 30
    case "year":
      return 365
    default:
      return 365
  }
}

/** The price (in cents) of one day of a plan that costs `price` per period. */
export function getPricePerDay({
  periodAmount,
  periodUnit,
  price,
}: {
  periodAmount: number
  periodUnit: string
  price: number
}): number {
  return price / getTotalDays({ periodAmount, periodUnit })
}
